import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageValencia = props => {
  return <CityLandingPage cityKey="Valencia" cityConfig={cityContent.valencia} {...props} />;
};

export default LandingPageValencia;
